module.exports = __webpack_public_path__ + "img/12.52c94186.png";